import { ELlmResponseType, provideAida } from '@adaptiva/ai/common';
import { artifactRenderers } from '@adaptiva/ai/widgets';
import { Licensing } from '@adaptiva/core/licensing';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminPortalModule } from './admin-portal.module';
import { AppComponent } from './app.component';
import { getAppRoutes } from './builds';

/**
 * @author Jesse Rogers <jesse.rogers@adaptiva.com>
 * @description Holds the targeted top-level feature modules for the active
 * 	application build. This module gets replaced by alternate build modules
 * 	for builds that need to add/remove compiled feature modules.
 */
@NgModule({
	imports: [
		AdminPortalModule,
		RouterModule.forRoot(getAppRoutes())
	],
	declarations: [AppComponent],
	exports: [
		AppComponent,
		RouterModule
	],
	providers: [
		provideAida({
			artifactTypes: [ELlmResponseType.DASHBOARD],
			artifactRenderers: artifactRenderers(),
			oemCompatibility: [Licensing.Products.Internal.ADAPTIVA],
		}),
	]
})
export class BuildModule {

}
